import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { formatImage } from '../../../../base/publicMethod/index';
import { getImageUrl, imageAttr } from '../utils/image';
import { formatPlayNum, asyncGetPlayNum } from '../utils/playNumUnit';
import { formatVideoDuration } from '../utils/formatVideoDuration';
import classNames from '../utils/classNames';
import styles from '../styles/styles.css';
import imageUrl from './imageUrl';
import { handleCallNewsApp, h5PageCount } from '../../../../utils';

/* 大图模式 */
class VideoChannleListImage extends PureComponent {
    static propTypes = {
        item: PropTypes.object,
        url: PropTypes.string,
        id: PropTypes.string,
        newstype: PropTypes.string,
        // pinglunUrl: PropTypes.string,
        countMapCache: PropTypes.object,
        isDisplaySource: PropTypes.bool,
        isCount: PropTypes.bool,
        isNewsTime: PropTypes.bool,
        isLazyImage: PropTypes.bool,
        isFormatTime: PropTypes.bool,
        videoPlayCache: PropTypes.object,
    };

    static defaultProps = {
        isDisplaySource: true,
        isCount: true,
        isNewsTime: true,
        isFormatTime: true,
    };

    handleClick = (url, id, newstype, kind, clickCountConfig) => {
        const nodata = '';
        const doc_type = newstype;
        const aid = id;
        const to_url = url;

        this.feedClickCountFn(clickCountConfig);

        handleCallNewsApp(nodata, doc_type, aid, to_url, 0, 0, kind);
    };

    feedClickCountFn = config => {
        if (config) {
            h5PageCount([config]);
        }
    };

    render() {
        const { url, item, isDisplaySource, isLazyImage, videoPlayCache } = this.props;
        const {
            type,
            title,
            thumbnail,
            thumbnails,
            source,
            id,
            videoCount,
            callUp,
            newstype,
            atlasMark,
            hasIcon,
            clickCount,
            kind,
        } = item;
        const isSource = isDisplaySource && source && source !== '';
        const width = imageAttr(375);
        const height = imageAttr(211);
        const props = { width, height, alt: title };
        const clickCountConfig = clickCount ? clickCount : '';
        const isVideo = type === 'video' || videoCount;

        let image = thumbnail && thumbnail !== '' ? thumbnail : thumbnails;

        image = image ? image : item.posterUrl;

        // thumbnails
        if (image && typeof image === 'object' && 'image' in image) {
            image = getImageUrl(image.image[0]);
        }

        const src = formatImage(image, 375, 211);

        if (isLazyImage) {
            props.src = isVideo ? imageUrl.none : imageUrl.big;
            props['data-lazy-src'] = src;
        } else {
            props.src = src;
        }

        const videoInfo = item => {
            return (
                <div className={styles.videoInfo}>
                    <span>{formatPlayNum(videoPlayCache[item.guid])}人观看</span>
                    <div className={styles.playNum}>{formatVideoDuration(item.duration)}</div>
                </div>
            );
        };

        return (
            <div className={styles.videolistItem} data-list-item>
                {callUp ? (
                    <Fragment>
                        <h4
                            className={classNames(styles.videoTitle, styles.title)}
                            onClick={this.handleClick.bind(this, url, id, newstype, kind, clickCountConfig)}>
                            <a href="javascript:;">{title}</a>
                        </h4>
                        <a
                            className={classNames(styles.grayBg, styles.bigImage, styles.videoBigImage)}
                            style={{ backgroundImage: `url('${isVideo ? imageUrl.none : imageUrl.big}')` }}
                            onClick={this.handleClick.bind(this, url, id, newstype, kind, clickCountConfig)}>
                            <img {...props} />
                            {atlasMark && <div className={styles.atlasMark}>图集</div>}
                            {!hasIcon ? <div className={styles.play} /> : null}
                            {videoInfo(item)}
                        </a>
                    </Fragment>
                ) : (
                    <Fragment>
                        <h4 className={classNames(styles.videoTitle, styles.title)}>
                            <a href={url}>{title}</a>
                        </h4>
                        <a
                            className={classNames(styles.grayBg, styles.bigImage, styles.videoBigImage)}
                            onClick={this.feedClickCountFn.bind(this, clickCountConfig)}
                            style={{ backgroundImage: `url('${isVideo ? imageUrl.none : imageUrl.big}')` }}
                            href={url}>
                            <img {...props} />
                            {isVideo ? <div className={styles.play} /> : null}
                            {videoInfo(item)}
                        </a>
                    </Fragment>
                )}
            </div>
        );
    }
}

export default VideoChannleListImage;
